import { Box, Button, Input, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import * as lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { TableHeadCell } from '../../../common/TableHeadCell'
import LibraryAdd from '@material-ui/icons/LibraryAdd'
import LibraryAddCheck from '@material-ui/icons/LibraryAddCheck'
import LibraryBooks from '@material-ui/icons/LibraryBooks'
import PresentToAllIcon from '@material-ui/icons/PresentToAll'
import LinearScaleIcon from '@material-ui/icons/LinearScale'
import {
  RepositoryDeploymentProperties,
  DeploymentProperties,
  Indicator,
  PipelineState,
  ChangeDeploymentFunction
} from '../../../../types'
import { SelectComponent } from '../../../common/Select'
import { BranchWarning } from './BranchWarining'
import { PipelineStateComponent } from './PipelineStateComponent'
import { Arrow } from '../../../common/Arrow'
import { SetTagButton } from './SetTagButton'

export function DeploymentTableComponent(props: {
  disabled: boolean
  repositories: RepositoryDeploymentProperties[]
  toDeploy: DeploymentProperties[]
  pipelineStates: PipelineState[]
  onDeployChange: ChangeDeploymentFunction
}) {
  const { disabled, repositories, toDeploy, pipelineStates, onDeployChange } = props
  const [isTagged, setIsTagged] = useState([] as Indicator<boolean>[])
  const [pipelineStatesIndicator, setPipelineStatesIndicator] = useState([] as Indicator<PipelineState>[])
  const [display, setDisplay] = useState(false)

  useEffect(() => {
    if (repositories.length > 0 && toDeploy.length > 0 && pipelineStates.length > 0) {
      setDisplay(true)
    }
  }, [repositories, toDeploy, pipelineStates])
  useEffect(() => {
    if (pipelineStates.length > 0) {
      setPipelineStatesIndicator(
        pipelineStates.map(pipelineState => {
          return {
            fetching: false,
            value: pipelineState
          }
        })
      )
    }
  }, [pipelineStates])
  useEffect(() => {
    if (toDeploy.length > 0) {
      setIsTagged(
        toDeploy.map((deploy: DeploymentProperties) => {
          return {
            fetching: false,
            value: deploy.upToDate
          }
        })
      )
    }
  }, [toDeploy])

  function onBranchChange(branch: string, index: number) {
    const newIsTagged = lodash.cloneDeep(isTagged)
    const newPipelineStates = lodash.cloneDeep(pipelineStatesIndicator)
    newPipelineStates[index].fetching = true
    newIsTagged[index].fetching = true
    setIsTagged(newIsTagged)
    setPipelineStatesIndicator(newPipelineStates)
    onDeployChange('CHANGE_BRANCH', index, branch)
  }

  function getNewTags() {
    const newIsTagged = isTagged.map(status => {
      status.fetching = !status.value ? true : false
      return status
    })
    setIsTagged(newIsTagged)
    onDeployChange('GET_NEW_TAG')
  }

  function getNewTag(index: number) {
    const newUpToDate = lodash.cloneDeep(isTagged)
    newUpToDate[index].fetching = true
    setIsTagged(newUpToDate)
    onDeployChange('GET_NEW_TAG', index)
  }

  function onTagChange(tag: string, index: number) {
    onDeployChange('CHANGE_TAG', index, tag)
  }

  function renderRepositories() {
    return toDeploy.map((repository: DeploymentProperties, index: number) => {
      const applyHighlight = toDeploy[index].tag !== repositories[index].lastTag ? 'highlight' : ''
      return (
        <TableRow className={applyHighlight} key={index}>
          <TableCell>
            <Typography variant='body1'>{repositories[index].name}</Typography>
          </TableCell>
          <TableCell>
            <Box className='flexCenter'>
              <Input key={index} disabled={disabled} readOnly value={repositories[index].lastTag} />
            </Box>
          </TableCell>
          <TableCell>
            <Arrow key={index} display={applyHighlight.length > 0} tip={'New Version'} />
          </TableCell>
          <TableCell>
            <Box className='flexCenter'>
              <SelectComponent
                key={'branch' + index}
                disabled={disabled}
                callback={onBranchChange}
                value={repository.branch}
                items={repositories[index].branches}
                index={index}
              />
              <SelectComponent
                key={'tag' + index}
                disabled={disabled}
                value={toDeploy[index].tag}
                items={toDeploy[index].tags.map(obj => obj.tag)}
                index={index}
                callback={onTagChange}
              />
              <BranchWarning key={index} repository={repositories[index]} />
            </Box>
          </TableCell>
          <TableCell>
            <SetTagButton
              key={index}
              indicator={isTagged[index]}
              callback={getNewTag}
              index={index}
              branch={toDeploy[index].branch}
            />
          </TableCell>
          <TableCell align='right'>
            <PipelineStateComponent key={index} indicator={pipelineStatesIndicator[index]} />
          </TableCell>
        </TableRow>
      )
    })
  }
  if (display) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableHeadCell width={20} text='Repository' icon={<LibraryBooks />} />
            <TableHeadCell width={15} text='Aktueller Release' icon={<LibraryAddCheck />} />
            <TableHeadCell width={5} />
            <TableHeadCell width={35} text='Neuer Release' icon={<LibraryAdd />} />
            <TableHeadCell
              width={10}
              icon={
                <Button className='no-padding' onClick={getNewTags}>
                  <PresentToAllIcon />
                </Button>
              }
            />
            <TableHeadCell
              width={15}
              text='Pipeline'
              icon={<LinearScaleIcon />}
              align='right'
              classNames='pipelineStatus'
            />
          </TableRow>
        </TableHead>
        <TableBody>{renderRepositories()}</TableBody>
      </Table>
    )
  }
  return null
}
